import type { DateFilters, OrderHistoryEntry } from '../types';
import { getEffectiveRefundStatus } from './refunds';

export type OrderStatusFilter = 'all' | 'needs_attention' | 'in_transit' | 'delivered' | 'refunds';
export type OrderDatePreset = 'all' | 'today' | '7days' | '30days' | 'custom';

export function matchesOrderStatus(order: Pick<OrderHistoryEntry, 'status' | 'refund_status' | 'tracking_status'>, filter?: string): boolean {
  if (!filter || filter === 'all') return true;
  const refund = getEffectiveRefundStatus(order);
  const status = String(order.tracking_status || order.status).toLowerCase();
  if (filter === 'refunds') return Boolean(refund);
  if (filter === 'needs_attention') return refund ? refund === 'rejected' : ['purchase_pending', 'purchase_failed', 'failure', 'error', 'return_to_sender'].includes(status) || ['purchase_pending', 'purchase_failed'].includes(order.status);
  if (refund) return false;
  if (filter === 'in_transit') return ['in_transit', 'out_for_delivery'].includes(status);
  return filter === 'delivered' && status === 'delivered';
}

export function localDateKey(date: Date): string {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

/** Date presets include today and use local calendar days, including DST boundaries. */
export function datePresetFilters(preset: OrderDatePreset, now = new Date()): Pick<DateFilters, 'date' | 'startDate' | 'endDate'> {
  if (preset === 'today') return { date: localDateKey(now) };
  if (preset === '7days' || preset === '30days') {
    const start = new Date(now);
    start.setDate(start.getDate() - (preset === '7days' ? 6 : 29));
    return { startDate: localDateKey(start), endDate: localDateKey(now) };
  }
  return {};
}
